import React from 'react';
import GoogleLoginButton from 'components/GoogleLoginButton';

export default function LoginPage() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', minHeight: '100vh', alignItems: 'center' }}>
            <div style={{ width: '100%', maxWidth: '400px', padding: '0 1em' }}>                
                <div style={{ textAlign: 'center', marginBottom: '2em' }}>
                    <h1>Inicia sesión en Restaurantero</h1>
                    <p>Accede con tu cuenta de Google para comenzar.</p>
                </div>
                
                <GoogleLoginButton />
            </div>
        </div>
    );
}
